/* eslint-disable arrow-body-style */
// @flow
import React from 'react';
import { t } from 'javascripts/utils/withTranslation';
import HeaderIcon from './HeaderIcon';

type Props = {
  link: string,
  label?: string,
  tooltip?: string,
};

const SearchFallBack = ({
  link,
  label,
  tooltip,
}: Props): React$MixedElement => {
  return (
    <HeaderIcon
      link={link}
      icon="search"
      label={label || t('Suche')}
      labelId="header-icon-label--search"
      tooltip={tooltip || t('Suche')}
    />
  );
};

export default SearchFallBack;
